import React from 'react';
import { Link } from 'react-router-dom';
import { XCircleIcon } from '@heroicons/react/24/outline';

/**
 * Landing page for Stripe's `cancel_url`.
 *
 * `supabase/functions/stripe-create-checkout/index.ts` has always sent
 * `cancel_url: ${rootUrl}/payment/cancel`, but no such route existed — so a customer who
 * backed out of Stripe Checkout was dropped on a 404, which reads as "something broke and
 * maybe I was charged anyway". Nothing is charged when a Checkout session is abandoned;
 * this page says so plainly and offers the way back.
 */
const PaymentCancelled = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center p-4">
    <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
      <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-6">
        <XCircleIcon className="w-10 h-10 text-gray-500" />
      </div>

      <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment cancelled</h1>
      <p className="text-gray-600 mb-6">
        No payment was taken and your card was not charged. Your invoice is still open whenever
        you're ready.
      </p>

      <Link
        to="/invoices"
        className="inline-block w-full px-6 py-3 bg-blue-600 text-white font-medium rounded-xl hover:bg-blue-700 transition-colors"
      >
        Back to My Invoices
      </Link>
    </div>
  </div>
);

export default PaymentCancelled;
